import React from 'react'

import { Page } from '../../../../../api/payload/payload-types'

import { Media } from '../Media'
import RichText from '../RichText'

import classes from './index.module.scss'

type Props = Extract<Page['layout'][0], { blockType: 'mediaBlock' }> & {
  id?: string
}

export const MediaBlock: React.FC<Props> = props => {
  const { media, position = 'default' } = props

  let caption
  if (media && typeof media === 'object') caption = media.caption

  return (
    <div className={classes.mediaBlock}>
      {position === 'fullscreen' && (
        <div className={classes.fullscreen}>
          <Media resource={media}  />
        </div>
      )}
      {position === 'default' && (
        /*<Gutter>*/
          <Media resource={media} />
       /* </Gutter>*/
      )}
      {caption && (
       /* <Gutter className={classes.caption}>*/
          <RichText content={caption} />
      /*  </Gutter>*/
      )}
    </div>
  )
}
